import { getTranslatedMessage } from './i18n.util';

import type { MessageInstance } from 'antd/es/message/interface';

export const successSaveMsg = async (
  messageApi: MessageInstance | undefined,
  isEdit: boolean,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage(
    isEdit ? 'message.successUpdate' : 'message.successSave',
    instance,
  );

  messageApi?.success(msg);
};

export const errorSaveMsg = async (
  messageApi: MessageInstance | undefined,
  isEdit: boolean,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage(
    isEdit ? 'message.errorUpdate' : 'message.errorSave',
    instance,
  );

  messageApi?.error(msg);
};

export const errorGetMsg = async (
  messageApi: MessageInstance | undefined,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage('message.errorGet', instance);

  messageApi?.error(msg);
};

export const errorDownloadMsg = async (
  messageApi: MessageInstance | undefined,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage('message.errorDownload', instance);

  messageApi?.error(msg);
};

export const successDeleteMsg = async (
  messageApi: MessageInstance | undefined,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage('message.successDelete', instance);

  messageApi?.success(msg);
};

export const errorDeleteMsg = async (
  messageApi: MessageInstance | undefined,
  instance: string = 'Entity',
) => {
  const msg = getTranslatedMessage('message.errorDelete', instance);

  messageApi?.error(msg);
};

export const networkError = async (messageApi: MessageInstance | undefined) => {
  const msg = getTranslatedMessage('error.noConnection');

  messageApi?.warning(msg);
};

// export const successSentVerificationEmail = async () => {
//   const { messageApi } = request.xhr.message;
//
//   const msg = await intl({
//     id: 'message.successSentVerificationEmail',
//     defaultMessage: 'Email verification has been sent',
//   });
//
//   messageApi.success(msg);
// };
//
// export const pendingEmailVerification = async () => {
//   const { messageApi } = request.xhr.message;
//
//   const msg = await intl({
//     id: 'message.pendingEmailVerification',
//     defaultMessage: 'Pending Email verification',
//   });
//
//   messageApi.warning(msg);
// };
//
// export const errorSentVerificationEmail = async () => {
//   const { messageApi } = request.xhr.message;
//
//   const msg = await intl({
//     id: 'message.errorSentVerificationEmail',
//     defaultMessage: 'Failed to send Email verification',
//   });
//
//   messageApi.error(msg);
// };
